import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import useReveal from "@/hooks/useReveal";

const contactEmail = "workwithdilip1@gmail.com";

const sections = [
    {
        title: "1. What LÜVYN provides",
        body: "LÜVYN is a dating product concept designed around curated introductions, compatibility signals, waitlist access, profile verification, messaging tools, and optional features such as date spot suggestions. During alpha or pre-launch phases, some features may be prototypes, limited by region, or unavailable without notice.",
    },
    {
        title: "2. Eligibility and account responsibility",
        body: "You must be at least 18 years old and legally allowed to use dating services in your location. You are responsible for the information you provide, keeping account access secure, and making sure your profile represents you honestly. Do not impersonate another person or create accounts for others without permission.",
    },
    {
        title: "3. Respectful use",
        body: "You agree not to harass, threaten, exploit, spam, stalk, scrape, mislead, or pressure other members. LÜVYN may limit visibility, pause access, remove content, or terminate accounts that create safety, trust, or abuse concerns.",
    },
    {
        title: "4. Matching and availability",
        body: "Matches are suggestions, not guarantees. Compatibility scores, curated introductions, date ideas, and profile prompts are informational and may be based on incomplete or evolving data. We do not guarantee romantic outcomes, replies, meetings, or continued availability of any person or feature.",
    },
    {
        title: "5. User content",
        body: "You keep ownership of profile text, photos, messages, and other content you submit. You grant LÜVYN the limited permission needed to host, display, process, moderate, and improve the service. Do not upload content you do not have rights to use.",
    },
    {
        title: "6. Safety and offline meetings",
        body: "You are responsible for your own decisions when communicating with or meeting someone. Meet in public, tell someone you trust, arrange your own transport, and leave if something feels wrong. Report safety concerns immediately.",
    },
    {
        title: "7. Payments and future subscriptions",
        body: "The alpha waitlist is currently presented as free. If paid features are introduced later, pricing, renewal terms, cancellation options, and refund rules will be shown before purchase.",
    },
    {
        title: "8. Changes, suspension, and termination",
        body: "We may update these terms, change features, or suspend access where needed for product, legal, security, or safety reasons. If terms materially change, we will make reasonable efforts to communicate the update.",
    },
    {
        title: "9. Contact",
        body: `Questions about these terms can be sent to ${contactEmail}.`,
    },
];

export default function Terms() {
    useReveal();

    return (
        <div className="relative min-h-screen overflow-x-hidden" data-testid="terms-page">
            <div className="grain" />
            <Header />
            <main id="top">
                <section className="relative pt-36 pb-20 lg:pt-44 lg:pb-28">
                    <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
                        <div className="reveal in font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--hot)] mb-8">
                            Legal edition · Terms and conditions
                        </div>
                        <h1 className="reveal in font-display text-[18vw] sm:text-[12vw] lg:text-[10rem] leading-[0.82] tracking-tighter">
                            Terms of{" "}
                            <span className="font-italic-serif text-[var(--hot)]">
                                service.
                            </span>
                        </h1>
                        <p className="reveal in mt-8 max-w-2xl text-lg leading-relaxed text-[var(--ink-soft)]">
                            These terms explain the rules for using LÜVYN, joining
                            the waitlist, creating a profile, communicating with
                            matches, and using future app features.
                        </p>
                    </div>
                </section>

                <section className="relative py-16 lg:py-24 bg-[var(--paper-2)] border-y-2 border-[var(--ink)]">
                    <div className="max-w-[1000px] mx-auto px-6 lg:px-10">
                        <div className="reveal bg-[var(--paper)] border-2 border-[var(--ink)] p-7 lg:p-10">
                            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--hot)] mb-8">
                                Last updated · May 11, 2026
                            </div>
                            <div className="space-y-9">
                                {sections.map((section) => (
                                    <section key={section.title}>
                                        <h2 className="font-display text-3xl lg:text-4xl leading-tight">
                                            {section.title}
                                        </h2>
                                        <p className="mt-3 leading-relaxed text-[var(--ink-soft)]">
                                            {section.body}
                                        </p>
                                    </section>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
